/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropType from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'

const CheckboxAdapter = ({
  checkedColor,
  className,
  isIndeterminate,
  label,
  labelColor,
  onChange,
  value,
}) => {
  const StyledCheckbox = withStyles({
    root: {
      color: labelColor,
      '&$checked': {
        color: checkedColor,
      },
    },
    checked: {},
  })((props) => (
    <Checkbox
      color="default"
      indeterminate={isIndeterminate}
      checked={value}
      onChange={onChange}
      {...props}
    />
  ))
  return (
    <FormControl style={{ color: labelColor }} className={className}>
      <FormControlLabel
        control={(
          <StyledCheckbox />
      )}
        labelPlacement="start"
        label={label}
      />
    </FormControl>
  )
}

CheckboxAdapter.defaultProps = {
  checkedColor: '',
  className: '',
  isIndeterminate: false,
  label: null,
  labelColor: '#000',
}

CheckboxAdapter.propTypes = {
  checkedColor: PropType.string,
  className: PropType.string,
  isIndeterminate: PropType.bool,
  label: PropType.node,
  labelColor: PropType.string,
  onChange: PropType.func.isRequired,
  value: PropType.bool.isRequired,
}

export default CheckboxAdapter
